import { render, staticRenderFns } from "./back_info.vue?vue&type=template&id=b83cc590&scoped=true&"
import script from "./back_info.vue?vue&type=script&lang=js&"
export * from "./back_info.vue?vue&type=script&lang=js&"
import style0 from "./back_info.vue?vue&type=style&index=0&id=b83cc590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83cc590",
  null
  
)

export default component.exports